export default function extractSampletReqUrlParams(url: string): { collaborationId?: string; token?: string } {
  try {
    const parsedUrl = new URL(url);

    const queryParams = new URLSearchParams(parsedUrl.search);
    const collab = queryParams.get('collab');

    const hashParams = new URLSearchParams(parsedUrl.hash.replace('#', ''));
    const token = hashParams.get('t');

    return { collaborationId: collab ?? undefined, token: token ?? undefined };
  } catch (error) {
    console.error('Invalid URL:', error);
    return {};
  }
}
